// ── Coach identity sync — is the local copy different from the stored one? ──
//
// ⚠️ THIS EXISTS TO HEAL A DRIFT THAT IS NORMALLY ABSENT. Server-side senders
// read the coach's identity out of coaches.settings, so boot pushed whatever
// localStorage held. It pushed it on EVERY page load, unconditionally — a
// database write, measured at 554 ms in boot wave 2 on 2026-09-09, for a
// payload that is almost always byte-identical to what is already stored.
//
// ⚠️ ONLY THE KEYS THAT ARE PRESENT COUNT. A coach who has never set a
// business phone has no businessPhone locally; that absence is not a change,
// and treating it as one would push an empty payload forever. Absent locally
// means "nothing to say", not "clear it".

/**
 * The identity keys boot syncs, in the order app.js built them.
 *
 * ⚠️ NO EMAIL-DOMAIN KEYS (2026-10-02). emailDomain, emailDomainStatus and
 * emailDomainId used to ride along. They decide which domain a coach's mail is
 * sent from, so only the server writes them now (save-coach-settings.js drops
 * them, _shared/server-owned-email-keys.js); sending them would only make boot
 * think something changed on every load.
 * @type {string[]}
 */
const SYNC_KEYS = [
  'emailBusinessName', 'businessName', 'coachName', 'coachEmail', 'businessPhone',
];

/**
 * @typedef {object} CoachSettingsSync
 * @property {Record<string, string>} payload The keys present locally.
 * @property {boolean} changed True when any key differs from what is stored.
 */

/**
 * @param {Record<string, any>} localSettings from config.loadSettings()
 * @param {Record<string, any>} storedSettings coaches.settings, already in hand
 * @returns {CoachSettingsSync}
 */
export function buildCoachSettingsSync(localSettings, storedSettings) {
  const local = localSettings || {};
  const stored = storedSettings || {};
  /** @type {Record<string, string>} */
  const payload = {};
  let changed = false;
  for (const key of SYNC_KEYS) {
    if (!local[key]) continue;
    payload[key] = local[key];
    if (stored[key] !== local[key]) changed = true;
  }
  return { payload, changed };
}

export { SYNC_KEYS };
